import { formatMoney } from '@shopify/theme-currency';
import getTileHTML from './get-tile-html';
import checkProductsExist from './check-products-exist';
import removeFromCart from './remove-from-cart';
import fetchUserLists from './fetch-user-lists';

// Save the list products on load to be able to send the object on remove
let saveforlater_products = [];

// Move a cart item to the saved for later list
const moveToSavedForLater = async (lineItem, lineNum, elem) => {
  return new Promise(async (resolve, reject) => {
    const itemData = window._swat.platform.transformCartItem(lineItem);
    itemData.du = `${window.location.origin}${itemData.du.substr(itemData.du.indexOf('/products/'))}`;

    if (window.theme.savedForLater.listId === 0) {
      const lists = await fetchUserLists();
      console.log('lists', lists);

      const saved_for_later_list = _.find(lists, { lname: 'My SFL List' });
      if (typeof saved_for_later_list === 'undefined') {
        // We would need to create a new list using https://developers.swym.it/docs/create-list
        // This case shouldn't be happening :)

        console.log(`Customer's saved for later list not found`);
        reject(`Customer's saved for later list not found`);
        return;
      }

      window.theme.savedForLater.listId = saved_for_later_list.lid;
    }

    // Success callback.
    const onSuccess = function(response) {
      console.log("Successfully Added the products to Save for Later List", response);
      removeFromCart(lineNum);
    };

    // Error Callback. 
    const onError = function(error) {
      // Error is an xhrObject
      console.log("There was an Error, while Adding products to the Save For Later List", error);
      reject(error);
      return;
    };

    window._swat.SaveForLater.add(
      window.theme.savedForLater.listId,
      [
        {
          du: itemData.du,
          empi: itemData.empi,
          epi: itemData.epi,
        }
      ],
      onSuccess,
      onError
    );
  });
};

// Button to move a cart item to the saved for later list
const initMoveToSavedForLater = () => {
  $(document).on('click', '[data-cart-save-for-later]', async (e) => {
    e.preventDefault();

    const elem = e.currentTarget;
    const lineNum = $(e.currentTarget).closest('[data-cart-item]').data('line');
    let lineItem = window.ShopifyCartData.items[lineNum - 1];
    
    // Move to save for later list and remove
    if (typeof lineItem !== 'undefined') {
      await moveToSavedForLater(lineItem, lineNum, elem);
      return;
    }

    $.getJSON('/cart.js', async (cart, textStatus) => {
      window.ShopifyCartData = cart;
      lineItem = window.ShopifyCartData.items[lineNum - 1];
      await moveToSavedForLater(lineItem, lineNum, elem);
    });
  });
};

const initRemoveFromSavedForLater = () => {
  $(document).on('click', '[data-cart-saveforlater-items] [data-remove-wishlist-item]', (e) => {
    if (!window._swat) {
      return;
    }

    const remove_id = $(e.currentTarget).closest('[data-cart-wishlist-item]').data('cart-wishlist-item-id');
    const remove_object = _.find(saveforlater_products, { id: remove_id });
    console.log('Remove from list', remove_id, remove_object);

    if (typeof remove_object === 'undefined') {
      return;
    }

    window._swat.deleteFromList(window.theme.savedForLater.listId, {
      du: remove_object.du,
      empi: remove_object.empi,
      epi: remove_object.epi,
    }, (response) => {
      // Successfully deleted, re-render page
      window.location.reload(false);
    }, (error) => {
      console.log('There was an Error, while Removing products to the Save For Later List', error);
    });
  });
};

export default () => {
  const itemsContainer = document.getElementById('saveforlater-items');

  if (!itemsContainer) {
    return;
  }

  // Saved for later list has been initialized correctly, we can now load the items, build and show them
  const onSuccess = function(response) {
    console.log('Successfully Initialized, and we created a Save for Later List', response);

    window.theme.savedForLater.listId = response.listid;
    // $('[data-cart-save-for-later]').removeClass('visually-hidden');
    // $('.cart-item__move-to-wishlist').css('padding-left', '16px');
    $('[data-cart-saveforlater-loading]').remove();

    // https://developers.swym.it/docs/fetch-list-details
    window._swat.fetchListDetails({
      'lid': window.theme.savedForLater.listId,
    }, (listDetails) => {
      console.log("Successfully fetched List details", listDetails);

      initMoveToSavedForLater();
      initRemoveFromSavedForLater();

      if (!listDetails.items.length) {
        $('[data-cart-saveforlater-empty]').addClass('visible');

        return;
      }

      saveforlater_products = listDetails.items;

      $('[data-cart-saveforlater-empty]').remove();

      let count_list_item = 0;
      _.each(saveforlater_products, (list_product) => {
        try {
          const option_html = getTileHTML(list_product, itemsContainer);
          $(`[data-cart-saveforlater-items] [data-cart-wishlist-item-id="${list_product.id}"] [data-cart-wishlist-item-options]`).html(option_html);

          if (window.Shopify.country === 'US') {
            $(`[data-cart-saveforlater-items] [data-cart-wishlist-item-id="${list_product.id}"] [data-cart-wishlist-item-price]`).html(formatMoney(Number(list_product.pr) * 100, theme.moneyFormat));
          } else {
            $(`[data-cart-saveforlater-items] [data-cart-wishlist-item-id="${list_product.id}"] [data-cart-wishlist-item-price]`).html(formatMoney(Math.ceil(Number(list_product.pr) * window.Shopify.currency.rate) * 100, theme.moneyFormat));
          }

          // Cleanup title
          let product_title = list_product.dt;
          if (product_title.indexOf(' - ') !== -1) {
            const product_title_parts = product_title.split(' - ');
            const last_title_part = product_title_parts[product_title_parts.length - 1];
            product_title = product_title.replace(` - ${last_title_part}`, '');
            $(`[data-cart-saveforlater-items] [data-cart-wishlist-item-id="${list_product.id}"] [data-cart-wishlist-item-title]`).html(product_title);
          }

          count_list_item++;

          // User might have a product that doesn't exist in store in its list, remove it if it's the case
          if (count_list_item === saveforlater_products.length) {
            checkProductsExist(list_product, 'saveforlater');
          }

          $(window).trigger('resize');
        } catch (error) {
          console.log('Save for later list error', error);
        }
      });
    }, (error) => {
      console.log("Error while fetching List details", error);
      return;
    });
  };
    
  // Call the Init function.
  if (typeof window._swat.SaveForLater !== 'undefined') {
    window._swat.SaveForLater.init(onSuccess, (error) => {
      console.log('There was an Error, while creating the Save For Later List', error);
    });
  }
};
